import { render, staticRenderFns } from "./EjectionsPage.vue?vue&type=template&id=384487bb&scoped=true"
import script from "./EjectionsPage.vue?vue&type=script&lang=js"
export * from "./EjectionsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384487bb",
  null
  
)

export default component.exports